// Keep integration branding out of operational messages, including upstream errors.
function storeMessage(value) {
  return typeof value === "string" ? value.replace(/\bTray\b/gi, "loja") : value;
}
function storeResponseMessages(value) {
  if (!value || typeof value !== "object") return value;
  if (Array.isArray(value)) return value.map(storeResponseMessages);
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [
      key,
      ["message", "warning", "error", "error_description"].includes(key) && typeof item === "string"
        ? storeMessage(item)
        : item && typeof item === "object"
        ? storeResponseMessages(item)
        : item,
    ])
  );
}
module.exports = { storeMessage, storeResponseMessages };
